<!-- 页面数据出错 -->
<template>
  <div class="complainSus" :style="{height: clientHeight+'px'}">
    <img src="../../assets/img/ic-status-success.png" alt="">
    <div>提交成功，</div>
    <div>您的评价会让我们做的更好</div>
  </div>
</template>

<script>
export default {
  name: 'complainSus',
  data() {
    return {
    };
  },
  mounted() {

  },
  methods: {

  },
  computed: {
    clientHeight() {
      return document.body.clientHeight;
    }
  }
};
</script>
<style lang="scss" scoped>
.complainSus {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img{
      width: 95px;
      height: 95px;
      margin-bottom: 20px;
  }
  div {
    font-size: 16px;
    color: #bfbfbf;
    margin-top: 5px;
  }
}
</style>
